export default function AlertIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <title>7CD598F7-1940-46B5-A9C1-6DD4F4211531</title>
      <g
        id="new-sign-up-/-log-in"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="1.2-email-alert-portal"
          transform="translate(-450.000000, -18.000000)"
          fill="#fa6400"
        >
          <g id="Group-5" transform="translate(450.000000, 15.000000)">
            <g
              id="icon-/-fill-/-warning"
              transform="translate(0.000000, 3.000000)"
            >
              <path
                d="M20.6346914,16.5267557 L14.2690898,4.79343924 C13.7886445,3.98364053 12.9401133,3.5 11.999332,3.5 C11.0585508,3.5 10.2100195,3.98364053 9.72957422,4.79343924 C9.72595312,4.79963434 9.72289453,4.80582944 9.71927344,4.81202455 L3.37483594,16.5082056 C2.88408984,17.3350761 2.87480859,18.3280879 3.34955859,19.164251 C3.82539844,20.0009069 4.68264844,20.5 5.64406641,20.5 L18.3194414,20.5 C19.2808594,20.5 20.1733359,20.0009069 20.6491406,19.164251 C21.1238906,18.3281231 21.1146445,17.3350409 20.6346914,16.5267557 Z M10.9435898,8.87245787 C10.9435898,8.28863969 11.4162656,7.81541819 11.999332,7.81541819 C12.5824336,7.81541819 13.0550742,8.28867489 13.0550742,8.87245787 L13.0550742,13.1006518 C13.0550742,13.6843996 12.5823984,14.1576915 11.999332,14.1576915 C11.4162656,14.1576915 10.9435898,13.6843644 10.9435898,13.1006518 L10.9435898,8.87245787 L10.9435898,8.87245787 Z M11.999332,18.3859206 C11.1260859,18.3859206 10.4156836,17.6746804 10.4156836,16.8003259 C10.4156836,15.9260066 11.1260508,15.2147664 11.999332,15.2147664 C12.8725781,15.2147664 13.5829453,15.9260066 13.5829453,16.8003259 C13.5829805,17.6746452 12.8726133,18.3859206 11.999332,18.3859206 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
